import styled from "styled-components";
import { H5 } from "../../../elements/v2/Typography/Heading";

export const Heading = styled(H5)`
  font-weight: 500;
  font-size: 15px;
  color: #000000;
`;
